webpackJsonp([10],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AuthLogin__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AuthRegister__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Main__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SideMenu__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MainMenu__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_bus__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "auth-login": __WEBPACK_IMPORTED_MODULE_3__components_AuthLogin__["a" /* default */],
    "auth-register": __WEBPACK_IMPORTED_MODULE_4__components_AuthRegister__["a" /* default */],
    "app-header": __WEBPACK_IMPORTED_MODULE_5__components_Header__["a" /* default */],
    "app-main": __WEBPACK_IMPORTED_MODULE_6__components_Main__["a" /* default */],
    "side-menu": __WEBPACK_IMPORTED_MODULE_7__components_SideMenu__["a" /* default */],
    "main-menu": __WEBPACK_IMPORTED_MODULE_8__components_MainMenu__["a" /* default */]
  },
  data: function data() {
    return {
      AppState: __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */],
      AppLoading: true,
      mainMenuOpen: false, // left menu open
      sideMenuOpen: false,
      menu: 0,
      view: "desktop"
    };
  },

  computed: {
    currentView: function currentView() {
      return "is" + this.view;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* FirebaseAuth */].onAuthStateChanged(function (user) {
      _this.AppLoading = false;
      if (!__WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.showRegister) {
        _this.login(user);
      }
    });
  },

  methods: {
    openMainMenu: function openMainMenu() {
      this.mainMenuOpen = true;
      this.menu = 0;
    },
    closeMainMenu: function closeMainMenu() {
      this.mainMenuOpen = false;
    },
    backMainMenu: function backMainMenu() {
      this.menu = 0;
    },
    setView: function setView(newView) {
      this.view = newView;
    },
    openSideMenu: function openSideMenu() {
      this.sideMenuOpen = true;
    },
    closeSideMenu: function closeSideMenu() {
      this.sideMenuOpen = false;
    },
    showMenu: function showMenu(i) {
      this.menu = i + 1;
    },
    showRegistration: function showRegistration() {
      __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.showRegister = true;
    },
    login: function login(user) {
      __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].loading = true;
      if (user) {
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* FirebaseStorage */].init(user.uid);
        // GET USER PROFILE
        __WEBPACK_IMPORTED_MODULE_1__firebase__["e" /* dbProfile */].doc(user.uid).get().then(function (profile) {
          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentProjectID = profile.data().currentProjectID;
          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPageID = profile.data().currentPageID;

          // GET USER PROJECTS
          __WEBPACK_IMPORTED_MODULE_1__firebase__["f" /* dbProjects */].where("userID", "==", user.uid).get().then(function (projects) {
            projects.forEach(function (doc) {
              __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].projects.push({
                id: doc.id,
                title: doc.data().title,
                activePageID: doc.data().activePageID,
                firebaseConfig: doc.data().firebaseConfig || null,
                createdAt: doc.data().createdAt,
                updatedAt: doc.data().updatedAt
              });
            });
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].projects.sort(function (a, b) {
              return a.createdAt > b.createdAt ? 1 : -1;
            });
            // SET CURRENT PROJECT
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentProject = __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].projects.filter(function (p) {
              return p.id === __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentProjectID;
            })[0] || { title: "" };
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.text = error;
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.show = true;
          });

          // GET USER SELECTED PROJECT'S PAGES
          __WEBPACK_IMPORTED_MODULE_1__firebase__["d" /* dbPages */].where("userID", "==", user.uid).where("projectID", "==", __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentProjectID).get().then(function (projectPages) {
            projectPages.forEach(function (doc) {
              __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].projectPages.push({
                id: doc.id,
                title: doc.data().title,
                blocks: JSON.parse(doc.data().blocks),
                loaded: [],
                loadedDone: [],
                blockID: doc.data().blockID,
                createdAt: doc.data().createdAt,
                updatedAt: doc.data().updatedAt
              });
            });
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].projectPages.sort(function (a, b) {
              return a.createdAt > b.createdAt ? 1 : -1;
            });
            // SET CURRENT PAGE
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPage = __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].projectPages.filter(function (p) {
              return p.id === __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPageID;
            })[0] || {
              title: "",
              projectID: "",
              blockID: 0,
              blocks: [],
              loaded: [],
              loadedDone: []
            };
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.text = error;
            __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.show = true;
          });

          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.isLogged = true;
          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.showRegister = false;
          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].loading = false;
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.text = error;
          __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.show = true;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.isLogged = false;
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.showRegister = false;
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].loading = false;
      }
    },
    logout: function logout() {
      this.menu = 0;
      this.mainMenuOpen = false;
      __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* FirebaseAuth */].signOut().then(function () {
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.isLogged = false;
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].Auth.showRegister = false;
        window.location.reload();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.text = error;
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].error.show = true;
      });
    },
    addBlock: function addBlock(block) {
      __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPage.blockID += 1;
      var newBlock = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(block));
      newBlock.blockID = __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPage.blockID;
      if (block.type === "nav") {
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPage.blocks.unshift(newBlock);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__util_AppState__["a" /* default */].currentPage.blocks.push(newBlock);
      }
      __WEBPACK_IMPORTED_MODULE_9__util_bus__["a" /* default */].$emit("addedBlock", newBlock); // , { blockID: newBlock.blockID }
    }
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable no-useless-escape */
  /* eslint-disable no-mixed-operators */
  data: function data() {
    return {
      AppState: __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */],
      valid: true,
      email: "",
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
        );
      }],
      password: "",
      passwordHidden: true,
      passwordRules: [function (v) {
        return v && v.length >= 8 || "Password must at least 8 characters";
      }],
      errorCode: "",
      errorMessage: ""
    };
  },

  methods: {
    loginUser: function loginUser() {
      this.errorCode = "";
      this.errorMessage = "";
      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* FirebaseAuth */].signInWithEmailAndPassword(this.email, this.password).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].error.text = error.message;
          __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].error.show = true;
        });
      }
    },
    showRegistration: function showRegistration() {
      this.$emit("showRegistration");
    }
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(36);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable no-useless-escape */
  /* eslint-disable no-mixed-operators */
  data: function data() {
    return {
      AppState: __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */],
      valid: true,
      registerDone: true,
      email: "",
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
        );
      }],
      password: "",
      passwordHidden: true,
      passwordRules: [function (v) {
        return v && v.length >= 8 || "Password must at least 8 characters";
      }]
    };
  },
  mounted: function mounted() {
    this.registerDone = false;
  },

  methods: {
    register: function register() {
      var _this = this;

      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].loading = true;
        __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* FirebaseAuth */].createUserWithEmailAndPassword(this.email, this.password).then(function (usr) {
          var now = new Date();
          // ADD DEFAULT PROJECT
          __WEBPACK_IMPORTED_MODULE_2__firebase__["f" /* dbProjects */].add({
            userID: usr.uid,
            title: "My Project",
            createdAt: now,
            updatedAt: now
          }).then(function (proj) {
            // ADD DEFAULT PAGE
            __WEBPACK_IMPORTED_MODULE_2__firebase__["d" /* dbPages */].add({
              userID: usr.uid,
              projectID: proj.id,
              title: "Landing Page",
              blocks: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]),
              blockID: 0,
              createdAt: now,
              updatedAt: now
            }).then(function (page) {
              // ADD DEFAULT SETTINGS WITH SELECTED PROJECT
              proj.update({ activePageID: page.id });
              __WEBPACK_IMPORTED_MODULE_2__firebase__["e" /* dbProfile */].doc(usr.uid).set({
                userID: usr.uid,
                currentProjectID: proj.id,
                currentPageID: page.id,
                createdAt: now,
                updatedAt: now
              }).then(function () {
                _this.registerDone = true;
                setTimeout(function () {
                  _this.$emit("login", usr);
                }, 2000);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.text = error;
                __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.show = true;
              });
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.text = error;
              __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.show = true;
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.text = error;
            __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.show = true;
          });
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.text = error;
          __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */].error.show = true;
        });
      }
    }
  }
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_bus__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["view"],
  data: function data() {
    return {
      AppState: __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */]
    };
  },

  computed: {
    subtitle: function subtitle() {
      return __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentProject.title + " - " + __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentPage.title;
    }
  },
  methods: {
    openMenu: function openMenu() {
      this.$emit("openMenu");
    },
    openSideMenu: function openSideMenu() {
      this.$emit("openSideMenu");
    },
    setView: function setView(v) {
      this.$emit("setView", v);
    },
    publish: function publish() {
      __WEBPACK_IMPORTED_MODULE_1__util_bus__["a" /* default */].$emit("publish");
    },
    saveTemp: function saveTemp() {
      __WEBPACK_IMPORTED_MODULE_1__util_bus__["a" /* default */].$emit("saveTemp");
    },
    loadTemp: function loadTemp() {
      __WEBPACK_IMPORTED_MODULE_1__util_bus__["a" /* default */].$emit("loadTemp");
    }
  }
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pretty__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pretty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pretty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downloadjs__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_bus__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // "block-nav": () => import("../blocks/BlockNav"),
    "block-header1": function blockHeader1() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 445));
    },
    "block-header2": function blockHeader2() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 446));
    },
    "block-parallax1": function blockParallax1() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 447));
    },
    "block-features1": function blockFeatures1() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 448));
    },
    "block-info1": function blockInfo1() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 449));
    }
    // "block-stats": () => import("../blocks/BlockStats"),
    // "block-contact": () => import("../blocks/BlockContact")
  },
  data: function data() {
    return {
      publishOpen: false,
      exportHtml: "",
      copyMsg: "",
      AppState: __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__util_bus__["a" /* default */].$on("publish", function () {
      __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].loading = true;
      __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].showSettings = false;
      _this.exportHtml = "";
      __WEBPACK_IMPORTED_MODULE_5__util_bus__["a" /* default */].$emit("prePublish");
      // Wait for editor cleanup
      _this.$nextTick(function () {
        _this.exportHtml = _this.$el.ownerDocument.documentElement.innerHTML.replace(/&quot;/g, "'")
        // .replace(/"\/static\//g, '"static/')
        .replace("<link type=\"text/css\" rel=\"stylesheet\" media=\"all\" href=\"" + __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].baseURL + "/static/templates/_preview.css\">", "").replace('<link type="text/css" rel="stylesheet" media="all" href="https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/medium-editor.min.css">', "").replace('<link type="text/css" rel="stylesheet" media="all" href="https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/themes/flat.css">', "");
        _this.exportHtml = __WEBPACK_IMPORTED_MODULE_1_pretty___default()("<!DOCTYPE html><html>" + _this.exportHtml + "</html>", { ocd: true });
        __WEBPACK_IMPORTED_MODULE_5__util_bus__["a" /* default */].$emit("postPublish");
        __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].showSettings = true;
        _this.publishOpen = true;
        __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].loading = false;
      });
    });
    __WEBPACK_IMPORTED_MODULE_5__util_bus__["a" /* default */].$on("saveTemp", function () {
      var p = __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].currentPage;
      __WEBPACK_IMPORTED_MODULE_3__firebase__["d" /* dbPages */].doc(p.id).update({
        blockID: p.blockID,
        blocks: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(p.blocks)
      });
    });
    __WEBPACK_IMPORTED_MODULE_5__util_bus__["a" /* default */].$on("loadTemp", function () {});
  },
  mounted: function mounted() {
    var _this2 = this;

    this.doc = this.$el.ownerDocument;
    this.win = this.doc.defaultView;
    __WEBPACK_IMPORTED_MODULE_5__util_bus__["a" /* default */].$on("addedBlock", function (bl) {
      _this2.$nextTick(function () {
        _this2.doc.body.scrollTop = bl.type === "nav" ? 0 : _this2.doc.body.scrollHeight;
      });
    });
  },

  methods: {
    popPublishClose: function popPublishClose() {
      this.publishOpen = false;
    },
    deleteBlock: function deleteBlock(block) {
      __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].currentPage.blocks = __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].currentPage.blocks.filter(function (el) {
        return el.blockID !== block.blockID;
      });
    },
    moveBlock: function moveBlock(params, block) {
      var index = 0;
      var blockList = __WEBPACK_IMPORTED_MODULE_4__util_AppState__["a" /* default */].currentPage.blocks;
      blockList.forEach(function (el, ind) {
        if (el.blockID === block.blockID) {
          index = ind;
        }
      });
      var movedBlock = blockList.splice(index, 1)[0];
      blockList.splice(index + params.dir, 0, movedBlock);
      this.$nextTick(function () {
        params.el.scrollIntoView({ behavior: "smooth" });
      });
    },
    copyClipboard: function copyClipboard() {
      var _this3 = this;

      if (this.$clipboard(this.exportHtml)) {
        this.$refs.txtExportHTML.$el.querySelector("textarea").select();
        this.copyMsg = "Copied to clipboard!";
      } else {
        this.$refs.txtExportHTML.$el.querySelector("textarea").select();
        this.copyMsg = "Press Ctrl+c to copy!";
      }
      setTimeout(function () {
        _this3.copyMsg = "";
      }, 3000);
    },
    downloadHtml: function downloadHtml() {
      // TODO: name the file from the page. And on page settings have title and filename.
      __WEBPACK_IMPORTED_MODULE_2_downloadjs___default()(this.exportHtml, "index.html", "text/html");
    }
  }
});

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blockTemplates__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(65);



var AppState = {
  baseURL: __WEBPACK_IMPORTED_MODULE_1__common__["a" /* baseURL */], // https://cortexial-app.firebaseapp.com
  title: "Cortexial",
  firebaseURL: "https://www.gstatic.com/firebasejs/4.6.1/firebase.js",
  firestoreURL: "https://www.gstatic.com/firebasejs/4.6.0/firebase-firestore.js",
  previewReady: false,
  loading: false,
  showSettings: true,
  Auth: {
    isLogged: false,
    showRegister: false
  },
  error: {
    show: false,
    text: ""
  },
  blockTemplates: __WEBPACK_IMPORTED_MODULE_0__blockTemplates__["a" /* default */],
  projects: [],
  projectPages: [],
  currentProjectID: null,
  currentProject: { title: "" },
  currentPageID: null,
  currentPage: {
    title: "",
    projectID: "",
    blockID: 0,
    blocks: [],
    loaded: [],
    loadedDone: []
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AppState);

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_utilities__ = __webpack_require__(180);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      AppState: __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */],
      isJson: __WEBPACK_IMPORTED_MODULE_1__util_utilities__["a" /* isJson */]
    };
  },

  computed: {
    navUsed: function navUsed() {
      var used = false;
      if (__WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentPage.blocks) {
        __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentPage.blocks.forEach(function (block) {
          if (block.type === "nav") used = true;
        });
      }
      return used;
    }
  },
  methods: {
    addBlock: function addBlock(b) {
      if (!(this.navUsed && b.type === "nav") && !(b.firebase && !Object(__WEBPACK_IMPORTED_MODULE_1__util_utilities__["a" /* isJson */])(__WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentProject.firebaseConfig))) {
        this.$emit("addBlock", b);
      }
    },
    closeClick: function closeClick() {
      this.$emit("closeClick");
    }
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "menu-projects": function menuProjects() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 450));
    },
    "menu-pages": function menuPages() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 451));
    },
    "menu-account": function menuAccount() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 452));
    },
    "menu-settings": function menuSettings() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 453));
    }
  },
  props: ["menu"],
  data: function data() {
    return {
      items: [{ icon: "folder", title: "Projects", subtitle: 1 }, { icon: "web_asset", title: "Pages", subtitle: 2 }, {
        icon: "account_circle",
        title: "Account",
        subtitle: __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* FirebaseAuth */].currentUser.email
      }, { icon: "settings", title: "Project Settings", subtitle: 1 }]
    };
  },

  methods: {
    subtitles: function subtitles(sub) {
      var cur = sub === 1 ? __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentProject.title : __WEBPACK_IMPORTED_MODULE_0__util_AppState__["a" /* default */].currentPage.title;
      return sub === 1 || sub === 2 ? cur : sub;
    },
    logout: function logout() {
      this.$emit("logout");
    },
    showMenu: function showMenu(i) {
      this.$emit("showMenu", i);
    },
    closeClick: function closeClick() {
      this.$emit("closeClick");
    },
    backToMenu: function backToMenu() {
      this.$emit("backToMenu");
    }
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isJson; });
/* unused harmony export camelCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


var isJson = function isJson(item) {
  var it = typeof item !== "string" ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item) : item;

  try {
    it = JSON.parse(it);
  } catch (e) {
    return false;
  }

  if ((typeof it === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(it)) === "object" && it !== null) {
    return true;
  }

  return false;
};

var camelCase = function camelCase(str) {
  var st = str.replace(/-/g, " ") // convert all hyphens to spaces
  .replace(/\s[a-z]/g, str.toLowerCase()) // convert first char of each word to UPPERCASE
  .replace(/\s+/g, "") // remove spaces
  .replace(/^[A-Z]/g, str.toUpperCase()); // convert first char to lowercase
  return st;
};



/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_clipboard__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_filters__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_AppState__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_bus__ = __webpack_require__(54);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



/* import MediumEditor from 'medium-editor'; */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: "#8BC34A",
    secondary: "#03A9F4",
    accent: "#FF9800",
    error: "#DA0000",
    info: "#00BCD4",
    success: "#4CAF50",
    warning: "#FFC107"
  }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_clipboard___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

// register global utility filters.
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__util_filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_6__util_filters__[key]);
});

/* Vue.directive('wysiwyg', {
  bind(el) {
    Vue.nextTick(() => new MediumEditor(el));
  }
}); */

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component("i-frame", {
  render: function render(h) {
    return h("iframe", {
      on: { load: this.renderChildren }
    });
  },
  beforeUpdate: function beforeUpdate() {
    // freezing to prevent unnessessary Reactifiation of vNodes
    this.iApp.children = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(this.$slots.default);
  },

  methods: {
    renderChildren: function renderChildren() {
      var _this = this;

      this.$nextTick(function () {
        var children = _this.$slots.default;
        var doc = _this.$el.contentDocument;
        var body = doc.body;
        var head = doc.head;
        // Add meta
        var meta = doc.createElement("meta");
        meta.httpEquiv = "X-UA-Compatible";
        meta.content = "IE=edge";
        head.appendChild(meta);
        var meta2 = doc.createElement("meta");
        meta2.charset = "utf-8";
        head.appendChild(meta2);
        _this.addMeta(doc, head, "viewport", "width=device-width, initial-scale=1, shrink-to-fit=no");
        // TODO: Add meta keywords, description, author etc

        // Styles for preview Editor
        _this.addStyle(doc, head, __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].baseURL + "/static/templates/_preview.css");
        _this.addStyle(doc, head, "https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/medium-editor.min.css");
        _this.addStyle(doc, head, "https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/themes/flat.css");

        // Styles for Theme 1
        // TODO: make google Fonts selectable at Page or Project Level
        body.className += " stretched";
        _this.addStyle(doc, head, "https://fonts.googleapis.com/css?family=Lato:300,400,400i|Montserrat:400,700");
        _this.addStyle(doc, head, "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css");
        _this.addStyle(doc, head, "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css");
        _this.addStyle(doc, head, __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].baseURL + "/static/templates/theme1/_themify.css");
        _this.addStyle(doc, head, __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].baseURL + "/static/templates/theme1/_style.css");
        _this.addStyle(doc, head, __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].baseURL + "/static/templates/theme1/_global.css");
        _this.addStyle(doc, head, __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].baseURL + "/static/templates/theme1/theme/red.css");
        // THEME: /theme1/theme/red.css  gold.css
        /* TODO: Favicons
        <link rel="shortcut icon" href="img/favicon.ico" type="image/x-icon">
        <link rel="apple-touch-icon" href="img/apple-touch-icon.png">
        */

        var el = doc.createElement("DIV"); // we will mount or nested app to this element
        body.appendChild(el);

        // Add Required Scripts
        _this.addScriptCb(doc, body, "https://code.jquery.com/jquery-1.12.4.min.js", // 1.11.4 is on theme.
        function () {
          _this.addScriptCb(doc, body, "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js", function () {
            _this.addScript(doc, body, __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].baseURL + "/static/templates/theme1/js/global.js");
            __WEBPACK_IMPORTED_MODULE_7__util_AppState__["a" /* default */].previewReady = true;
            __WEBPACK_IMPORTED_MODULE_8__util_bus__["a" /* default */].$emit("previewInit"); // , { blockID: newBlock.blockID }
          });
        });

        var iApp = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
          name: "iApp",
          // freezing to prevent unnessessary Reactifiation of vNodes
          data: { children: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(children) },
          render: function render(h) {
            return h("div", this.children);
          }
        });
        iApp.$mount(el); // mount into iframe
        _this.iApp = iApp; // cache instance for later updates
      });
    },
    addStyle: function addStyle(doc, head, src) {
      var link = doc.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.media = "all";
      link.href = src;
      head.appendChild(link);
    },
    addScriptCb: function addScriptCb(doc, body, src, callback) {
      var script = doc.createElement("script");
      script.type = "text/javascript";
      if (script.readyState) {
        // IE
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = function () {
          callback();
        };
      }
      script.src = src;
      body.appendChild(script);
    },
    addScript: function addScript(doc, body, src) {
      var script = doc.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      body.appendChild(script);
    },
    addMeta: function addMeta(doc, head, name, content) {
      var meta = doc.createElement("meta");
      meta.name = name;
      meta.content = content;
      head.appendChild(meta);
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: "#app",
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e5ac6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(331);
function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e5ac6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blockTemplatesHeader__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockTemplatesParallax__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blockTemplatesFeatures__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blockTemplatesInfo__ = __webpack_require__(281);
// Cannot import AppState as it imports this
// import BlockTemplatesMenu from "./blockTemplatesMenu";





/* harmony default export */ __webpack_exports__["a"] = ([
// NAVIGATION MENU
/* {
  id: 10,
  type: "nav",
  title: "Navigation Menu",
  templates: BlockTemplatesMenu
}, */
// HEADERS
{
  id: 20,
  type: "header",
  title: "Headers",
  templates: __WEBPACK_IMPORTED_MODULE_0__blockTemplatesHeader__["a" /* default */]
},
// PARALLAX ********************
{
  id: 30,
  type: "parallax",
  title: "Parallax",
  templates: __WEBPACK_IMPORTED_MODULE_1__blockTemplatesParallax__["a" /* default */]
},
// FEATURES ********************
{
  id: 40,
  type: "features",
  title: "Features",
  templates: __WEBPACK_IMPORTED_MODULE_2__blockTemplatesFeatures__["a" /* default */]
},
// INFO ********************
{
  id: 50,
  type: "info",
  title: "Info",
  templates: __WEBPACK_IMPORTED_MODULE_3__blockTemplatesInfo__["a" /* default */]
}]);

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(65);


// HEADERS
/* harmony default export */ __webpack_exports__["a"] = ([{
  // HEADER 1 - SWIPE SLIDER
  id: 201,
  type: "header",
  title: "Swipe Slider Header",
  template: "block-header1",
  hasScript: true,
  firebase: false,
  required: [{ title: "swiper", js: "swiper.js", css: "swiper.css" }],
  options: {
    fullHeight: true,
    scrollNext: { enabled: true, text: "LEARN MORE" },
    pagination: "arrows",
    slides: [{
      id: 1,
      bg: {
        url: __WEBPACK_IMPORTED_MODULE_0__common__["a" /* baseURL */] + "/static/templates/theme1/img/bg/01.jpg",
        color: "transparent"
      },
      title: { text: "A theme with personality", color: "#ffffff" },
      subtitle: {
        text: "This is a powerful theme with some great features that you can use in your future projects.",
        color: "rgba(255, 255, 255, 0.8)"
      },
      align: "left",
      buttons: [{
        id: 1,
        href: "#",
        target: "_self",
        text: "Get Started Now",
        type: "primary"
      }]
    }, {
      id: 2,
      bg: {
        url: __WEBPACK_IMPORTED_MODULE_0__common__["a" /* baseURL */] + "/static/templates/theme1/img/bg/02.jpg",
        color: "red"
      },
      title: { text: "A theme with diversity", color: "#ffffff" },
      subtitle: {
        text: "All the texts are editable.",
        color: "rgba(255, 255, 255, 0.8)"
      },
      align: "right",
      buttons: [{
        id: 1,
        href: "#",
        target: "_self",
        text: "Read More",
        type: "primary"
      }]
    }]
  },
  settings: [{ el: "fullHeight", title: "Full Height", type: "toggle" }, { el: "scrollNext.enabled", title: "Scroll down", type: "toggle" }, { el: "scrollNext.text", title: "Scroll down Text", type: "input" }, {
    el: "pagination",
    title: "Pagination",
    type: "select",
    options: [{ text: "Arrows", value: "arrows" }, { text: "Bottom dots", value: "bdots" }]
  }, {
    el: "slides",
    title: "Slides",
    type: "array",
    children: [{ el: "bg", title: "Background URL", type: "image" }, { el: "bg.color", title: "Background Color", type: "color" }, { el: "title.text", title: "Title Text", type: "input" }, { el: "title.color", title: "Title Color", type: "color" }, { el: "subtitle.text", title: "Subtitle Text", type: "input" }, { el: "subtitle.color", title: "Subtitle Color", type: "color" }, {
      el: "align",
      title: "Align",
      type: "select",
      options: [{ text: "Left", value: "left" }, { text: "Center", value: "center" }, { text: "Right", value: "right" }]
    }, {
      el: "buttons",
      title: "Buttons",
      type: "array",
      children: [{ el: "href", title: "Button href", type: "input" }, { el: "text", title: "Button text", type: "input" }, {
        el: "type",
        title: "Button type",
        type: "select",
        options: [{ text: "Primary", value: "primary" }, { text: "Secondary", value: "secondary" }, { text: "Accent", value: "accent" }]
      }, {
        el: "target",
        title: "Button target",
        type: "select",
        options: [{ text: "Same Window", value: "_self" }, { text: "New Tab", value: "_blank" }, { text: "Top Window (for iframes)", value: "_top" }]
      }]
    }]
  }]
}, // /HEADER 1 - SWIPE SLIDER
{
  // HEADER 2 - DATE
  id: 202,
  type: "header",
  title: "Event - Video Header",
  template: "block-header2",
  hasScript: false,
  firebase: false,
  required: [{
    title: "magnific-popup",
    js: "magnific-popup.js",
    css: "magnific-popup.css"
  }],
  options: {
    fullHeight: true,
    scrollNext: { enabled: true, text: "LEARN MORE" },
    bg: {
      url: __WEBPACK_IMPORTED_MODULE_0__common__["a" /* baseURL */] + "/static/templates/theme1/img/bg/09.jpg",
      color: "transparent"
    },
    title: {
      text: "The New York<br>Event. Cortexial App.",
      color: "#ffffff"
    },
    subtitle: {
      text: "The time has come to bring those ideas and plans to life. This is where we really begin to visualize your napkin sketches and make them into beautiful pixels.",
      color: "rgba(255, 255, 255, 0.8)"
    },
    date: {
      dayText: "21",
      dayColor: "#c54041",
      monthText: "Dec",
      monthColor: "rgba(255, 255, 255, 0.5)",
      yearText: "2017",
      yearColor: "rgba(255, 255, 255, 0.5)"
    },
    align: "left",
    vidButton: {
      href: "https://www.youtube.com/watch?v=TJ1SDXbij8Y",
      title: "Intro Video",
      text: "Watch the Overview",
      type: "primary"
    }
  },
  settings: [{ el: "fullHeight", title: "Full Height", type: "toggle" }, { el: "scrollNext.enabled", title: "Scroll down", type: "toggle" }, { el: "scrollNext.text", title: "Scroll down Text", type: "input" }, { el: "bg", title: "Background URL", type: "image" }, { el: "bg.color", title: "Background Color", type: "color" },
  // { el: "title.text", title: "Title Text", type: "input" },
  { el: "title.color", title: "Title Color", type: "color" },
  // { el: "subtitle.text", title: "Subtitle Text", type: "input" },
  { el: "subtitle.color", title: "Subtitle Color", type: "color" },
  // { el: "date.dayText", title: "Date Day", type: "input" },
  { el: "date.dayColor", title: "Date Day Color", type: "color" },
  // { el: "date.monthText", title: "Date Month", type: "input" },
  { el: "date.monthColor", title: "Date Month Color", type: "color" },
  // { el: "date.yearText", title: "Date Year", type: "input" },
  { el: "date.yearColor", title: "Date Year Color", type: "color" }, {
    el: "vidButton.href",
    title: "Video Button Youtube URL",
    type: "input"
  }, { el: "vidButton.title", title: "Video Button Title", type: "input" }, { el: "vidButton.text", title: "Video Button Text", type: "input" }, {
    el: "vidButton.type",
    title: "Video Button Type",
    type: "select",
    options: [{ text: "Primary", value: "primary" }, { text: "Secondary", value: "secondary" }, { text: "Accent", value: "accent" }]
  }] // HEADER 2 - DATE
}]);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ([{
  // PARALLAX 1
  id: 301,
  type: "parallax",
  title: "Simple Parallax",
  template: "block-parallax1",
  hasScript: true,
  firebase: false,
  required: [{
    title: "parallax",
    js: "parallax.js",
    css: null
  }],
  options: {
    fullHeight: false,
    parallax: { percentage: "20", speed: 0.6 },
    bg: {
      url: __WEBPACK_IMPORTED_MODULE_0__common__["a" /* baseURL */] + "/static/templates/theme1/img/bg/03.jpg",
      color: "transparent"
    },
    title: {
      text: "The Fastest Way To Develop",
      color: "#ffffff"
    },
    subtitle: {
      text: "Lorem ipsum dolor sit amet, erat sit penatibus gravida elit, sed sagittis eleifend metus posuere eu etiam, sit porta sed, nam amet.",
      color: "rgba(255, 255, 255, 0.8)"
    },
    buttons: [{
      id: 1,
      href: "#",
      target: "_self",
      text: "Learn More",
      type: "primary"
    }]
  },
  settings: [{ el: "fullHeight", title: "Full Height", type: "toggle" }, { el: "bg", title: "Background URL", type: "image" }, {
    el: "parallax.percentage",
    title: "Parallax Top Position %",
    type: "slider",
    min: 0,
    max: 100
  }, {
    el: "parallax.speed",
    title: "Parallax Speed",
    type: "slider",
    min: 0,
    max: 1,
    step: 0.1
  }, { el: "bg.color", title: "Background Color", type: "color" }, { el: "title.color", title: "Title Color", type: "color" }, { el: "subtitle.color", title: "Subtitle Color", type: "color" }, {
    el: "buttons",
    title: "Buttons",
    type: "array",
    children: [{ el: "href", title: "Button href", type: "input" }, { el: "text", title: "Button text", type: "input" }, {
      el: "type",
      title: "Button type",
      type: "select",
      options: [{ text: "Primary", value: "primary" }, { text: "Secondary", value: "secondary" }, { text: "Accent", value: "accent" }]
    }, {
      el: "target",
      title: "Button target",
      type: "select",
      options: [{ text: "Same Window", value: "_self" }, { text: "New Tab", value: "_blank" }, { text: "Top Window (for iframes)", value: "_top" }]
    }]
  }]
}]);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  // FEATURES 1
  id: 401,
  type: "features",
  title: "Features Block",
  template: "block-features1",
  hasScript: false,
  firebase: false,
  required: [],
  options: {
    fullHeight: false,
    bg: {
      url: null,
      color: "#ffffff"
    },
    title: {
      text: "Welcome to Cortexial",
      colorTheme: "g-color--primary"
    },
    subtitle: {
      text: "We Create Beautiful Experiences <br> That Drive Successful Businesses.",
      colorTheme: "g-color--base"
    },
    features: [{
      id: 1,
      icon: { code: "ti-desktop", colorTheme: "g-color--primary" },
      title: { text: "Responsive Layout", colorTheme: "g-color--base" },
      subtitle: {
        text: "This is where we sit down, grab a cup of coffee and dial in the details.",
        colorTheme: "g-color--base"
      }
    }, {
      id: 2,
      icon: { code: "ti-settings", colorTheme: "g-color--primary" },
      title: { text: "Fully Customizable", colorTheme: "g-color--base" },
      subtitle: {
        text: "This is where we sit down, grab a cup of coffee and dial in the details.",
        colorTheme: "g-color--base"
      }
    }, {
      id: 3,
      icon: { code: "ti-ruler-alt-2", colorTheme: "g-color--primary" },
      title: { text: "Pixel Perfect", colorTheme: "g-color--base" },
      subtitle: {
        text: "This is where we sit down, grab a cup of coffee and dial in the details.",
        colorTheme: "g-color--base"
      }
    }, {
      id: 4,
      icon: { code: "ti-package", colorTheme: "g-color--primary" },
      title: { text: "Endless Possibilities", colorTheme: "g-color--base" },
      subtitle: {
        text: "This is where we sit down, grab a cup of coffee and dial in the details.",
        colorTheme: "g-color--base"
      }
    }, {
      id: 5,
      icon: { code: "ti-star", colorTheme: "g-color--primary" },
      title: { text: "Powerful Performance", colorTheme: "g-color--base" },
      subtitle: {
        text: "This is where we sit down, grab a cup of coffee and dial in the details.",
        colorTheme: "g-color--base"
      }
    }, {
      id: 6,
      icon: { code: "ti-panel", colorTheme: "g-color--primary" },
      title: { text: "Parallax Support", colorTheme: "g-color--base" },
      subtitle: {
        text: "This is where we sit down, grab a cup of coffee and dial in the details.",
        colorTheme: "g-color--base"
      }
    }]
  },
  settings: [{ el: "fullHeight", title: "Full Height", type: "toggle" }, { el: "bg", title: "Background URL", type: "image" }, { el: "bg.color", title: "Background Color", type: "color" }, { el: "title.colorTheme", title: "Title Color", type: "colorTheme" }, {
    el: "subtitle.colorTheme",
    title: "Subtitle Color",
    type: "colorTheme"
  }, {
    el: "features",
    title: "Features",
    type: "array",
    children: [{ el: "icon.code", title: "Feature Icon", type: "icon" }, {
      el: "icon.colorTheme",
      title: "Feature Icon Color",
      type: "colorTheme"
    }, { el: "title.text", title: "Feature Icon Title", type: "input" }, {
      el: "title.colorTheme",
      title: "Feature Icon Title Color",
      type: "colorTheme"
    }, {
      el: "subtitle.text",
      title: "Feature Icon Subtitle",
      type: "input"
    }, {
      el: "subtitle.colorTheme",
      title: "Feature Icon Subtitle Color",
      type: "colorTheme"
    }]
  }]
}]);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ([{
  // INFO 1
  id: 501,
  type: "info",
  title: "Info About",
  template: "block-info1",
  hasScript: false,
  firebase: false,
  required: [],
  options: {
    bg: {
      color: "#ffffff"
    },
    categoryTitle: {
      text: "Culture",
      colorTheme: "g-color--primary"
    },
    title: {
      text: "About <br> Cortexial",
      colorTheme: "g-color--base"
    },
    subtitle: {
      text: "We aim high at being focused on building relationships with our clients and community. Using our creative gifts drives this foundation. The time has come to bring those ideas and plans to life. This is where we really begin to visualize your napkin sketches and make them into beautiful pixels.<br><br>Now that your brand is all dressed up and ready to party, it's time to release it to the world. By the way, let's celebrate already.",
      colorTheme: "g-color--base"
    },
    image: {
      url: __WEBPACK_IMPORTED_MODULE_0__common__["a" /* baseURL */] + "/static/templates/theme1/img/970/01.jpg"
    }
  },
  settings: [{ el: "image", title: "Image URL", type: "image" }, { el: "bg.color", title: "Background Color", type: "color" }, {
    el: "categoryTitle.colorTheme",
    title: "Category Title Color",
    type: "colorTheme"
  }, { el: "title.colorTheme", title: "Title Color", type: "colorTheme" }, {
    el: "subtitle.colorTheme",
    title: "Subtitle Color",
    type: "colorTheme"
  }]
}]);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLogin_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a82f11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLogin_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a82f11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"grid":"","align-center":"","justify-center":""}},[_c('v-container',{attrs:{"grid-list-xl":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('img',{staticClass:"xs-12",attrs:{"src":"/static/img/v.png","alt":"Cortexial"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md4":"","offset-md4":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-mail","autocomplete":"username","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","autocomplete":"current-password","min":"8","counter":"","required":"","append-icon":_vm.passwordHidden ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.passwordHidden = !_vm.passwordHidden); },"type":_vm.passwordHidden ? 'password' : 'text',"rules":_vm.passwordRules},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"large":"","round":"","color":"secondary","disabled":!_vm.valid || _vm.AppState.loading},on:{"click":_vm.loginUser}},[_vm._v(" Login ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"red--text"},[_vm._v("\n            "+_vm._s(_vm.errorMessage)+"\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('a',{staticClass:"red--text",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.showRegistration()}}},[_vm._v("Register for an account")])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthRegister_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd9afd8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthRegister_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd9afd8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"grid":"","align-center":"","justify-center":""}},[_c('v-container',{attrs:{"grid-list-xl":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('img',{staticClass:"xs-12",attrs:{"src":"/static/img/v.png","alt":"Cortexial"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md4":"","offset-md4":""}},[(!_vm.registerDone)?_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-mail","autocomplete":"username","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","autocomplete":"new-password","min":"8","counter":"","required":"","append-icon":_vm.passwordHidden ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.passwordHidden = !_vm.passwordHidden); },"type":_vm.passwordHidden ? 'password' : 'text',"rules":_vm.passwordRules},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"large":"","round":"","color":"secondary","disabled":!_vm.valid || _vm.AppState.loading},on:{"click":_vm.register}},[_vm._v(" Register ")])],1):_vm._e(),_vm._v(" "),(_vm.registerDone)?_c('h2',[_vm._v("Registration succesful.")]):_vm._e(),_vm._v(" "),(_vm.registerDone)?_c('h3',[_vm._v("Logging you in... please wait")]):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aff007a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aff007a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"app":"","fixed":"","clipped-left":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.openMenu($event)}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("\n    "+_vm._s(_vm.AppState.title)+"\n    "),_c('div',{staticClass:"subheading",domProps:{"textContent":_vm._s(_vm.subtitle)}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){$event.stopPropagation();_vm.setView('Desktop')}},slot:"activator"},[_c('v-icon',[_vm._v("desktop_windows")])],1),_vm._v(" "),_c('span',[_vm._v("Switch to Desktop view")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){$event.stopPropagation();_vm.setView('Mobile')}},slot:"activator"},[_c('v-icon',[_vm._v("smartphone")])],1),_vm._v(" "),_c('span',[_vm._v("Switch to Mobile view")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){$event.stopPropagation();_vm.setView('FbTab')}},slot:"activator"},[_c('v-icon',[_vm._v("fa-facebook-official")])],1),_vm._v(" "),_c('span',[_vm._v("Switch to Facebook Tab view")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"mr-5",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.saveTemp($event)}}},[_vm._v(" Save ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-5",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.loadTemp($event)}}},[_vm._v(" Load ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-5",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.publish($event)}}},[_vm._v(" Publish ")]),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"dark":"","fab":""},on:{"click":function($event){$event.stopPropagation();_vm.openSideMenu($event)}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ef78ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ef78ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"preview"}},_vm._l((_vm.AppState.currentPage.blocks),function(block,i){return _c(block.template,{key:block.blockID,tag:"component",attrs:{"block":block,"order":i},on:{"deleteBlock":function($event){_vm.deleteBlock(block)},"moveBlock":function($event){_vm.moveBlock($event, block)}}})})),_vm._v(" "),_c('a',{staticClass:"s-back-to-top js__back-to-top",attrs:{"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.AppState.showSettings)?_c('v-dialog',{attrs:{"lazy":"","max-width":"800px","scrollable":"","persistent":""},model:{value:(_vm.publishOpen),callback:function ($$v) {_vm.publishOpen=$$v},expression:"publishOpen"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Publish Page")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"txtExportHTML",attrs:{"box":"","multi-line":"","label":"Export HTML","value":_vm.exportHtml}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('button',{on:{"click":_vm.copyClipboard}},[_vm._v("Copy to clipboard")]),_vm._v(" "),_c('span',{staticClass:"pl-4 green--text darken-1",domProps:{"textContent":_vm._s(_vm.copyMsg)}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('button',{on:{"click":_vm.downloadHtml}},[_vm._v("Download as HTML")])])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.popPublishClose($event)}}},[_vm._v("Close")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc1fd8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__(327);
function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc1fd8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sideMenu"},[_c('v-btn',{attrs:{"dark":"","block":"","color":"accent"},on:{"click":function($event){$event.stopPropagation();_vm.closeClick($event)}}},[_vm._v("Close")]),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.AppState.blockTemplates),function(templateCat){return _c('v-expansion-panel-content',{key:templateCat.type,attrs:{"value":true}},[_c('div',{attrs:{"slot":"header"},domProps:{"textContent":_vm._s(templateCat.title)},slot:"header"}),_vm._v(" "),_vm._l((templateCat.templates),function(template){return _c('a',{key:template.id,style:({ opacity: _vm.navUsed && template.type === 'nav' ? '0.3' : '1' }),attrs:{"href":"#","title":template.title},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.addBlock(template)}}},[_c('img',{attrs:{"src":'static/templates/theme1/' + template.template + '.jpg',"alt":""}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(template.firebase && !_vm.isJson(_vm.AppState.currentProject.firebaseConfig)),expression:"template.firebase && !isJson(AppState.currentProject.firebaseConfig)"}],staticClass:"side-block-disabled"},[_vm._v("Need to add Firebase details in Project Settings")])])})],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db0e537_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__(330);
function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db0e537_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"dark":"","block":"","color":"accent"},on:{"click":function($event){$event.stopPropagation();_vm.closeClick($event)}}},[_vm._v("Close")]),_vm._v(" "),(_vm.menu == 0)?_c('v-list',[_vm._l((_vm.items),function(item,i){return _c('v-list-tile',{key:i,attrs:{"value":"true","two-line":"","subheader":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showMenu(i)}}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"textContent":_vm._s(_vm.subtitles(item.subtitle))}})],1)],1)}),_vm._v(" "),_c('v-list-tile',{attrs:{"value":"true"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.logout()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Logout")])],1)],1)],2):_vm._e(),_vm._v(" "),(_vm.menu == 1)?_c('menu-projects',{attrs:{"item":_vm.items[0]},on:{"backToMenu":_vm.backToMenu}}):_vm._e(),_vm._v(" "),(_vm.menu == 2)?_c('menu-pages',{attrs:{"item":_vm.items[1]},on:{"backToMenu":_vm.backToMenu}}):_vm._e(),_vm._v(" "),(_vm.menu == 3)?_c('menu-account',{attrs:{"item":_vm.items[2]},on:{"backToMenu":_vm.backToMenu}}):_vm._e(),_vm._v(" "),(_vm.menu == 4)?_c('menu-settings',{attrs:{"item":_vm.items[3]},on:{"backToMenu":_vm.backToMenu}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[(_vm.AppLoading)?_c('div',[_c('h1',[_vm._v("Please Wait...")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.AppState.loading),expression:"AppState.loading"}],attrs:{"id":"loading-indicator"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":60,"width":7,"color":"red"}})],1),_vm._v(" "),(!_vm.AppLoading)?[(!_vm.AppState.Auth.isLogged && !_vm.AppState.Auth.showRegister)?_c('auth-login',{on:{"showRegistration":_vm.showRegistration}}):_vm._e(),_vm._v(" "),(!_vm.AppState.Auth.isLogged && _vm.AppState.Auth.showRegister)?_c('auth-register',{on:{"login":function($event){_vm.login($event)}}}):_vm._e(),_vm._v(" "),(_vm.AppState.Auth.isLogged)?[_c('div',{staticClass:"sidemenu"},[_c('v-navigation-drawer',{attrs:{"app":"","absolute":"","floating":"","clipped":""},model:{value:(_vm.mainMenuOpen),callback:function ($$v) {_vm.mainMenuOpen=$$v},expression:"mainMenuOpen"}},[_c('main-menu',{attrs:{"menu":_vm.menu},on:{"logout":_vm.logout,"showMenu":function($event){_vm.showMenu($event)},"closeClick":_vm.closeMainMenu,"backToMenu":_vm.backMainMenu}})],1)],1),_vm._v(" "),_c('app-header',{attrs:{"view":_vm.view},on:{"openMenu":_vm.openMainMenu,"setView":function($event){_vm.setView($event)},"openSideMenu":_vm.openSideMenu}}),_vm._v(" "),_c('i-frame',{class:['main-frame', _vm.currentView]},[_c('app-main')],1),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"menu_bg",attrs:{"fixed":"","temporary":"","right":""},model:{value:(_vm.sideMenuOpen),callback:function ($$v) {_vm.sideMenuOpen=$$v},expression:"sideMenuOpen"}},[_c('side-menu',{on:{"addBlock":function($event){_vm.addBlock($event)},"closeClick":_vm.closeSideMenu}})],1)]:_vm._e()]:_vm._e(),_vm._v(" "),_c('v-snackbar',{attrs:{"multi-line":true,"vertical":true},model:{value:(_vm.AppState.error.show),callback:function ($$v) {_vm.$set(_vm.AppState.error, "show", $$v)},expression:"AppState.error.show"}},[_vm._v("\n    "+_vm._s(_vm.AppState.error.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","color":"secondary"},nativeOn:{"click":function($event){_vm.AppState.error.show = false}}},[_vm._v("Close")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "relativeDate", function() { return relativeDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fullDate", function() { return fullDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_esm__ = __webpack_require__(333);


var relativeDate = function relativeDate(date) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm__["b" /* formatRelative */])(date, new Date());
};

var fullDate = function fullDate(date) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm__["a" /* format */])(date, "ddd, MMM Do YYYY");
}; // Sun, Dec 31st 1990



/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FirebaseApp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FirebaseAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FirebaseStorage; });
/* unused harmony export FirebaseDb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return batch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dbProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dbProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dbPages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_storage__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_firestore__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_firestore__);





var config = {
  apiKey: "AIzaSyAbPd0p3Qc4ERROtagJuU2_fsNkd4NsXJE",
  authDomain: "cortexial-app.firebaseapp.com",
  databaseURL: "https://cortexial-app.firebaseio.com",
  projectId: "cortexial-app",
  storageBucket: "cortexial-app.appspot.com",
  messagingSenderId: "767580810580"
};

var FirebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["initializeApp"](config);
var FirebaseAuth = FirebaseApp.auth();
var FirebaseDb = FirebaseApp.firestore(); // https://firebase.google.com/docs/firestore/manage-data/enable-offline
var FirebaseStorage = {
  init: function init(uid) {
    this.storage = FirebaseApp.storage();
    this.ref = this.storage.ref();
    this.images = this.ref.child(uid + "/images");
    this.videos = this.ref.child(uid + "/videos");
  },

  images: null,
  videos: null,
  storage: null,
  ref: null
};
/* const FirebaseStorage = {
  init(uid) {
    this.storage = FirebaseApp.storage(`gs://${uid}`);
    this.ref = this.storage.ref();
  },
  storage: null,
  ref: null
}; */

var batch = FirebaseDb.batch();

var dbProfile = FirebaseDb.collection("profile"); // profile?
var dbProjects = FirebaseDb.collection("projects");
var dbPages = FirebaseDb.collection("pages"); // or as array in project?

FirebaseAuth.setPersistence("local");



/* db.enablePersistence().then(function() {
  // Initialize Cloud Firestore through firebase
  var db = firebase.firestore();
}).catch(function(err) {
  if (err.code == 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code == 'unimplemented') {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
}); */
// https://firebase.google.com/docs/firestore/quickstart?authuser=0

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(116);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseURL; });
/* unused harmony export env */
var baseURL =  false ? "http://localhost:9090" : "https://app.cortexial.com";

var env = "production";



/***/ })

},[181]);


// WEBPACK FOOTER //
// static/js/app.eab17c5ed14d581a0fa8.js